"use client";

import type { AnchorHTMLAttributes, MouseEvent } from "react";

type TrackedLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  eventName: string;
  eventProps?: Record<string, string>;
};

export default function TrackedLink({
  eventName,
  eventProps,
  onClick,
  ...props
}: TrackedLinkProps) {
  function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    const analyticsWindow = window as typeof window & {
      plausible?: (name: string, options?: { props: Record<string, string> }) => void;
    };

    analyticsWindow.plausible?.(
      eventName,
      eventProps ? { props: eventProps } : undefined,
    );
    onClick?.(event);
  }

  return <a {...props} onClick={handleClick} />;
}
